const $errors = Symbol("Errors");
export class Validator {
    constructor(rules) {
        this.rules = rules;
        // debugger;
    }
    validateArray(obj) {
        const validationResults = validateTopLevelArrayRules(obj, this.rules);
        return {
            getErrors: function () {
                let errors = this[$errors];
                if (errors)
                    return errors;
                const { extractErrorsFromArray } = errorExtractor();
                errors = extractErrorsFromArray(validationResults);
                this[$errors] = errors;
                return errors;
            },
            isValid: function () {
                let errors = this[$errors];
                if (!errors) {
                    const { extractErrorsFromArray } = errorExtractor();
                    errors = extractErrorsFromArray(validationResults);
                    this[$errors] = errors;
                }
                for (const path in errors) {
                    if (errors[path].length > 0)
                        return false;
                }
                return true;
            }
        };
    }
    validate(obj) {
        const validationResult = validateInternal(obj, this.rules);
        return {
            getErrors: function () {
                let errors = this[$errors];
                if (errors)
                    return errors;
                const { extractErrors } = errorExtractor();
                errors = extractErrors(validationResult);
                this[$errors] = errors;
                return errors;
            },
            isValid: function () {
                let errors = this[$errors];
                if (!errors) {
                    const { extractErrors } = errorExtractor();
                    errors = extractErrors(validationResult);
                    this[$errors] = errors;
                }
                for (const path in errors) {
                    if (errors[path].length > 0)
                        return false;
                }
                return true;
            }
        };
    }
}
function validateInternal(obj, validationRules) {
    const validationResult = {};
    // let propResult: ValidationError | undefined;
    for (const prop2 in validationRules) {
        const prop = prop2;
        const propRules = validationRules[prop];
        if (prop === "__self") {
            const objectResult = validateSelfRules(obj, validationRules.__self);
            if (objectResult) {
                validationResult.__self = { messages: objectResult };
            }
        }
        else if (prop === "__if") {
            for (const [condition, rules] of validationRules.__if) {
                const canProceed = condition(obj);
                if (canProceed) {
                    const ifResult = validateInternal(obj, rules);
                    mergeInto(validationResult, ifResult);
                }
            }
        }
        else {
            const primitiveRules = propRules ? propRules : [];
            const itemRules = propRules && "item" in propRules ? propRules.item : undefined;
            const itemsRules = propRules && "items" in propRules ? propRules.items : undefined;
            if (primitiveRules?.length > 0) {
                const propResult = validatePropertyRules(obj, prop, primitiveRules);
                if (propResult.length > 0)
                    validationResult[prop] = { messages: propResult };
            }
            if (itemRules) {
                const objectResult = validateObjectPropRules(obj, prop, itemRules);
                if (objectResult)
                    validationResult[prop] = { ...validationResult[prop], __object: objectResult };
            }
            else if (itemsRules) {
                const arrayResult = validateArrayPropRules(obj, prop, itemsRules);
                if (arrayResult)
                    validationResult[prop] = { ...validationResult[prop], __array: arrayResult };
            }
        }
    }
    return validationResult;
}
function evalulateObjectErrorMessage(obj, message) {
    return typeof message === "function" ? message(obj) : (message || "object is invalid");
}
function evalulatePropErrorMessage(obj, propertyName, message) {
    return typeof message === "function" ? message(obj[propertyName], obj) : (message || `${propertyName} is invalid`);
}
function validateSelfRules(obj, rules) {
    if (!rules)
        return undefined;
    const returnValue = [];
    for (const r of rules) {
        const isValid = r.predicate(obj);
        if (isValid === false) {
            returnValue.push(evalulateObjectErrorMessage(obj, r.message));
        }
    }
    return returnValue;
}
function validateTopLevelArrayRules(objectArray, arrayRules) {
    if (!objectArray)
        return [];
    if (!(objectArray instanceof Array))
        return [];
    const arrayError = new Array(objectArray.length);
    for (let index = 0; index < objectArray.length; index++) {
        const item = objectArray[index];
        if (!arrayRules || !item) {
            continue;
        }
        const result = validateInternal(item, arrayRules);
        arrayError[index] = result;
    }
    if (arrayError.every(item => item === undefined))
        return [];
    return arrayError;
}
function validateArrayPropRules(obj, propertyName, arrayRules) {
    const objectArray = obj[propertyName];
    if (!objectArray)
        return [];
    if (!(objectArray instanceof Array))
        return [];
    const filter = arrayRules.condition;
    if (filter && !filter(objectArray, obj))
        return [];
    const arrayError = new Array(objectArray.length);
    for (let index = 0; index < objectArray.length; index++) {
        const item = objectArray[index];
        if (!arrayRules || !item) {
            continue;
        }
        const result = validateInternal(item, arrayRules.rule);
        arrayError[index] = result;
    }
    if (arrayError.every(item => item === undefined))
        return [];
    return arrayError;
}
function validateObjectPropRules(obj, propertyName, objectRules) {
    let objectError = undefined;
    const item = obj[propertyName];
    if (!objectRules || !item) {
        return objectError;
    }
    const filter = objectRules.condition;
    if (filter && !filter(item, obj))
        return objectError;
    objectError = validateInternal(item, objectRules.rule);
    return objectError;
}
function validatePropertyRules(obj, propertyName, rules) {
    if (!rules)
        return [];
    const returnValue = [];
    if (!obj)
        return [];
    for (const r of rules) {
        const isWhen = r.condition ? r.condition(obj) : true;
        const isValid = isWhen ? r.predicate(obj[propertyName], obj) : true;
        if (isValid === false) {
            returnValue.push(evalulatePropErrorMessage(obj, propertyName, r.message));
            break;
        }
    }
    return returnValue;
}
export const errorExtractor = () => {
    let propMessages = {};
    let objectMessages = {};
    function em(result, path) {
        if (!result)
            return;
        for (const key in result) {
            const { messages, __object: object, __array: array } = result[key] || {};
            const fullPath = `${path}.${key}`;
            if (object || array) {
                if (object) {
                    em(object, fullPath);
                }
                else if (array) {
                    array.forEach((arrayItem, index) => em(arrayItem, `${fullPath}.[${index}]`));
                }
                if (messages)
                    objectMessages[fullPath] = messages;
            }
            else {
                if (messages)
                    propMessages[fullPath] = messages;
            }
        }
    }
    return {
        extractErrorsFromArray: function (validationResults) {
            propMessages = {};
            objectMessages = {};
            validationResults.forEach((arrayItem, index) => em(arrayItem, `..[${index}]`));
            return { ...propMessages, ...objectMessages };
        },
        extractErrors: function (validationResult) {
            propMessages = {};
            objectMessages = {};
            em(validationResult, "");
            return { ...propMessages, ...objectMessages };
        }
    };
};
const mergeInto = (target, source) => {
    const mergeArrayInto = (targetArray, sourceArray) => {
        if (sourceArray) {
            const count = Math.max(sourceArray.length, targetArray.length);
            const resultArray = new Array(count);
            for (let i = 0; i < count; i++) {
                const sourceItem = sourceArray[i];
                const targetItem = targetArray[i];
                resultArray[i] = targetItem ? mergeInto(targetItem, sourceItem) : sourceItem;
            }
            return resultArray;
        }
        return targetArray;
    };
    if (source) {
        for (const key in source) {
            if (source[key]) {
                if (!target[key]) {
                    target[key] = source[key];
                }
                else {
                    const { messages: sourceMessages = [], __object: sourceObject, __array: sourceArray } = source[key] || {};
                    const { messages: targetMessages = [], __object: targetObject, __array: targetArray } = target[key] || {};
                    target[key] = {
                        messages: Array.from(new Set([...targetMessages, ...sourceMessages])),
                        __object: targetObject ? mergeInto(targetObject, sourceObject) : sourceObject,
                        __array: targetArray ? mergeArrayInto(targetArray, sourceArray) : sourceArray,
                    };
                }
            }
        }
        return source;
    }
    return target;
};
